
<h1 class="noSiteSelected" *ngIf="NoStieIdSelected == true">{{ 'Plese_select_site' | translate }}</h1>
<app-multisiteinfo *ngIf="isJobsidePreviewMode" [ActiveSiteId]="ActiveSiteId" [multiplesiteidsinfo]="multiplesiteidsinfo" (siteSelected)="switchsite($event)"></app-multisiteinfo>
<div class="job-side-preview-container" *ngIf="NoStieIdSelected == false || isJobPreviewMode == true">
    <app-page-header [importHeaderinfo]="exportheaderinfo"></app-page-header>

     <div class="clearfix home" id="content"
        [ngClass]="{noBkgImage: theme.data.backgroundImage.selected == 'none', noJobDescriptions: !bJobDescriptions}">
    
        <div #homeContent class="clearfix homeContent" role="main" aria-label="Main Content">
            <div class="clearfix jobDetailsMainDiv" role="region" [attr.aria-label]="'AriaLabel_JobDetails' | translate"
                tabindex="0">
                <h1 class="JDPreviewheader" *ngIf="isJobPreviewMode && jobDetailFields != null">{{ 'Lbl_JobPostingPrev' | translate }}</h1>
                
                <div class="jobDetailsLiner" *ngIf="jobDetailFields != null && isActive" tabindex="0">
                    <div class="questionClass">
                        <div *ngFor="let oQ of jobDetailQuestions | showjobdetailsfieldsbyQId: JobFieldsToDisplay">
                        <p *ngIf="oQ.QuestionName != '' && oQ.AnswerValue != '' && oQ.AnswerValue != null"
                                [ngClass]="oQ.ClassName" [innerHTML]="oQ.QuestionName |htmlencode "
                                class="question thick"></p>
                            <span *ngIf="oQ.ClassName == 'jobtitleInJobDetails'">
                                <span *ngIf="isHotJob && isJobPreviewMode " class="featuredJobs fa fa-fire" title="{{ 'AriaLabel_FeaturedJob' | translate }}">
                                <span class="screenReaderText">{{ 'AriaLabel_FeaturedJob' | translate }}</span>
                                </span>
                                <span class="referralJobs" *ngIf="isJobPreviewMode && enableSocialReferral && !jobDetailFields?.isSocialReferralJobRestricted" title="{{ 'AriaLabel_AllowsReferral' | translate }}">
                                    <i aria-hidden="true" class="fa fa-user"> <i aria-hidden="true" class="fa fa-user-o"></i></i>
                                    <span class="screenReaderText">{{ 'AriaLabel_AllowsReferral' | translate }}</span>
                                </span>
                                <h2 [ngClass]="oQ.ClassName" [innerHTML]="oQ.AnswerValue | htmlencode | translate"
                                    class="answer" tabindex="0" [attr.title]="oQ.ClassName"></h2>
                            </span>
                            <p *ngIf="oQ.ClassName != 'jobtitleInJobDetails' && oQ.ClassName != 'jobdescriptionInJobDetails'"
                                [ngClass]="oQ.ClassName" [innerHTML]="oQ.AnswerValue  |htmlencode | safeHtml" class="answer">
                            </p>
                            
                            <p *ngIf="oQ.ClassName == 'jobdescriptionInJobDetails' && oQ.AnswerValue != '' && oQ.AnswerValue != null"
                                [ngClass]="oQ.ClassName" [innerHTML]="oQ.AnswerValue |htmlencode | generateAndDisplayMediaTags  "
                                class="answer"></p>
                        </div>
                    </div>
                </div>
                <div class="mainContainer jobdetailNoJob newMsgContainer" role="alert" *ngIf="jobDetailFields == null && isJobPreviewMode"  tabindex="0" >
                <div class="iconContainer BkgWarning">
                        <i class="fa fa-exclamation-triangle" role="presentation"></i>
                    </div>
                    <div class="msgContainer BorderWarning">
                        <span id="appLbl" aria-live="assertive" class="JobFieldsMessage">{{'JobDetails_Inactivejob' | translate}}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="isJobPreviewMode && jobDetailFields != null" class="jobDetailsFooter jobDetailsMainDiv clearfix" role="navigation" [attr.aria-label]="'AriaLabel_Actions' | translate" tabindex="0">
                <div class="buttonsFooterAccentWrapper">
                    <div class="buttonsFooterAccent" ng-class="{socialMediaPopulated:pageData.ClientSettings[ 'ShowSocMediaButtonsOnJobDetailsPage' ]=='yes'}">
                        <div>
                            <button class="primaryButton ladda-button" (click)="WinClose()"><span>{{ 'Lbl_ClosePreview' | translate }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <page-footer #footer [footerInfofromParent]="exportfooterinfo"></page-footer> 
    </div>
</div>
